import Swiper from 'swiper/swiper-bundle.min';
export default (function () {
  var mobileSlider = null;
  var mediaMobile = 767;

  function mobileSliderInit() {
    if (!mobileSlider) {
      mobileSlider = new Swiper('.news-slider .swiper-container', {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.news-slider .swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        speed: 1000,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 0
          }
        }
      });
    }
  }

  function mobileSliderDestroy() {
    if (mobileSlider) {
      mobileSlider.destroy();
      mobileSlider = null;
    }
  }

  $(window).on('load resize', function () {
    var windowWidth = $(this).innerWidth();

    if (windowWidth <= mediaMobile) {
      mobileSliderInit();
    } else {
      mobileSliderDestroy();
    }
  });
});